module.exports = __webpack_public_path__ + "static/media/dashboard.873b674f.svg";